import React, { Suspense } from "react";
import "./App.css";
import SuspanceLoading from "./components/SuspanceLoading";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Layout from "./LayoutUtils/Layout";
import ProtectedRoutes from "./LayoutUtils/ProtectedRoutes";

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Layout>
        <Suspense fallback={<SuspanceLoading />}>
          <ProtectedRoutes />
        </Suspense>
      </Layout>
    </LocalizationProvider>
  );
}

export default App;
